import React from 'react';
import { Menu } from './components/Menu';
import { Content } from './components/Content';
import { StateProvider } from './context/StateProvider';

function App() {
  return (
    <StateProvider>
      <Menu />
      <Content />
    </StateProvider>
    
  );
}

export default App;
